module.exports = {"id":"202445","name":"Rodrigo Ely","rating":"75","photo":"./data/images/photos/0/202445.png","club":{"name":"Deport. Alavés","logo":"./data/images/clubs/Deport.Alaves.png"},"positions":["DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RodrigoEly0.json
// module id = 3666
// module chunks = 0